import { Routes } from '@angular/router';
import {DashboardComponent} from "./dashboard/dashboard.component";
import {AboutComponent} from "./about/about.component";
import {PricingComponent} from "./pricing/pricing.component";
import {ReferencesComponent} from "./references/references.component";
import {AuthGuard} from "./services/auth.guard";
import {AdminComponent} from "./admin/admin.component";
import {AdminLeaguesComponent} from "./admin/leagues/admin-leagues.component";
import {AdminUsersComponent} from "./admin/users/admin-users.component";
import {AdminServerParamsComponent} from "./admin/server-params/admin-server-params.component";
import {AdminUploadsComponent} from "./admin/uploads/admin-uploads.component";
import {SentryExample} from "./sentry-example.component";
import {BroadcastSetupComponent} from "./broadcast-setup/broadcast-setup.component";
import {BroadcastListComponent} from "./broadcast-list/broadcast-list.component";
import {BroadcastLayerComponent} from "./broadcast-layer-module/broadcast-layer/broadcast-layer.component";
import {ScoreSheetComponent} from "./score-sheet/score-sheet.component";
import {ScoreSheetListComponent} from "./score-sheet-list/score-sheet-list.component";
import {BroadcastControlComponent} from "./broadcast-control/broadcast-control.component";
import {LeagueDialogComponent} from "./admin/league-dialog/league-dialog.component";
import {UserOutputComponent} from "./broadcast-layer-module/user-output/user-output.component";
import {UserOutputUrlComponent} from "./user-output-url/user-output-url.component";
import {EvaluationComponent} from "./evaluation/evaluation.component";
import {EvaluationSeasonOverviewComponent} from "./evaluation/season-overview/season-overview.component";
import {EvaluationCriteriaOverviewComponent} from "./evaluation/criteria-overview/criteria-overview.component";
import {EvaluationGuideComponent} from "./evaluation/guide/guide.component";
import {EvaluationReviewWizardComponent} from "./evaluation/review-wizard/review-wizard.component";
import {EvaluationProducerGamesComponent} from "./evaluation/producer-games/producer-games.component";
import {EvaluationGameDetailComponent} from "./evaluation/game-detail/game-detail.component";

export const routes: Routes = [
  {path: 'about', component: AboutComponent},
  {path: 'pricing', component: PricingComponent},
  {path: 'references', component: ReferencesComponent},
  {path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard]},
  {path: 'broadcast', component: BroadcastListComponent, canActivate: [AuthGuard]},
  {path: 'broadcast/:uid', component: BroadcastSetupComponent, canActivate: [AuthGuard]},
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AuthGuard],
    data: {roles: ["admin"]},
    children: [
      {path: '', redirectTo: 'leagues', pathMatch: 'full'},
      {path: 'leagues', component: AdminLeaguesComponent},
      {path: 'league/:uid', component: LeagueDialogComponent},
      {path: 'users', component: AdminUsersComponent},
      {path: 'server-params', component: AdminServerParamsComponent},
      {path: 'uploads', component: AdminUploadsComponent},
      {path: 'sentry', component: SentryExample},
    ]
  },
  {
    // Broadcast evaluation. Admins and evaluation admins run the season,
    // producers sign off their own broadcasts; the guard lets all three in and
    // each screen shows only its own. `evaluationAdmin` is deliberately absent
    // from the `/admin` route above — that is the whole point of the role.
    path: 'evaluation',
    component: EvaluationComponent,
    canActivate: [AuthGuard],
    data: {roles: ["admin", "evaluationAdmin", "producer"]},
    children: [
      {path: '', redirectTo: 'season', pathMatch: 'full'},
      {path: 'season', component: EvaluationSeasonOverviewComponent},
      {path: 'criteria', component: EvaluationCriteriaOverviewComponent},
      {path: 'review', component: EvaluationReviewWizardComponent},
      {path: 'my-games', component: EvaluationProducerGamesComponent},
      {path: 'game/:videoId', component: EvaluationGameDetailComponent},
      // Open to both roles on purpose: a production company that can read
      // how the amount is arrived at argues about the broadcast, not about
      // the arithmetic.
      {path: 'guide', component: EvaluationGuideComponent},
    ]
  },
  {path: 'broadcast-layer/:uid', component: BroadcastLayerComponent, data: {fullscreen: true}},
  {path: 'broadcast-layer/:uid/:component', component: BroadcastLayerComponent, data: {fullscreen: true}},
  {path: 'user-layer/:user-uid', component: UserOutputComponent, data: {fullscreen: true}},
  {path: 'user-layer/:user-uid/:component', component: UserOutputComponent, data: {fullscreen: true}},
  {path: 'user-output-url', component: UserOutputUrlComponent},
  {path: 'broadcast-control/:uid', component: BroadcastControlComponent, data: {fullscreen: true}},
  {path: 'score-sheets', component: ScoreSheetListComponent},
  {path: 'score-sheet/game/:gameId', component: ScoreSheetComponent},
  {path: 'score-sheet/:uid', component: ScoreSheetComponent},
  {path: '**', redirectTo: 'about'}
];

// No NgModule needed for standalone components
